/*
 * @Author: changcheng
 * @LastEditTime: 2023-12-27 13:21:53
 */
import { useEffect, useState } from "react";
import {
  UserOutlined,
  EyeInvisibleOutlined,
  SafetyCertificateOutlined,
} from "@ant-design/icons";
import { Modal, Button, Form, Input } from "antd";
import {
  getCodeImage,
  login,
  getUserInfo,
  getInstituteList,
  getUserInfoByUserId,
  getAuthMenuData,
} from "@root/common/service";
import { useDispatch, useSelector } from "react-redux";
import { setUserInfo } from "@root/reducers/user";
import "./_style.scss";
import { RootState } from "@root/store";
import ConfirmUserInfo from "../confirmUserInfo/index";
import { queryInstituteList } from "@root/common/utils";
import { useNavigate } from "react-router-dom";
const { Search } = Input;
interface LoginPropsType {
  showLogin: boolean;
  setShowLogin: <T extends boolean>(type: T) => void;
}
export default function Login<T extends LoginPropsType>(props: T) {
  const directionaries = useSelector((item: RootState) => item.directionaries);
  const { showLogin, setShowLogin } = props;
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [showConfirmUserInfo, setShowConfirmUserInfo] = useState(false);
  const [imgCode, setImgCode] = useState({
    url: "",
    uuid: "",
  });
  /**
   * 获取验证码
   */
  const queryGetCodeImage = async () => {
    const { img, uuid } = await getCodeImage();
    setImgCode({
      url: `data:image/gif;base64,${img}`,
      uuid,
    });
  };
  /**
   * 登录
   * @param values
   */
  const onFinish = async (values: any) => {
    const { uuid } = imgCode;
    const { username } = values;
    const {
      code,
      data: { access_token },
    } = await login({ uuid, ...values });
    if (code === 200) {
      dispatch(
        // 存储token，因为获取用户信息依赖token
        setUserInfo({
          access_token,
        })
      );
      // 获取用户详情
      const {
        user: {
          userName,
          instituteId,
          baseUserCategory,
          userId,
          mainFlag,
          confirmFlag,
        },
        institute: { baseRegistrationStatus, provinceCode, isCountyProject },
      } = await getUserInfo();
      const { data = [] } = await getUserInfoByUserId(userId);
      const authMenuData = await getAuthMenuData();
      const roleMap = Object.keys(authMenuData.data);
      dispatch(
        setUserInfo({
          access_token,
          userName,
          instituteId,
          baseUserCategory,
          baseRegistrationStatus,
          userDetailInfo: data[0],
          provinceCode,
          userId,
          isCountyProject,
          roleMap,
          mainFlag,
        })
      );
      setShowLogin(false);
      // 需要补充信息
      if (confirmFlag === "2") {
        setShowConfirmUserInfo(true);
      } else {
        navigate("/home/index");
      }
    }
  };
  useEffect(() => {
    queryGetCodeImage();
    queryInstituteList("");
  }, [showLogin]);
  return (
    <div>
      <Modal
        title="登录"
        visible={showLogin}
        footer={null}
        onCancel={() => {
          setShowLogin(false);
        }}
        destroyOnClose={true}
      >
        <Form
          name="basic"
          initialValues={{ remember: true }}
          onFinish={onFinish}
          autoComplete="off"
          style={{
            width: "360px",
            margin: "0 auto",
          }}
        >
          <Form.Item
            name="username"
            rules={[{ required: true, message: "请输入用户名" }]}
          >
            <Input
              size="large"
              addonBefore={<UserOutlined />}
              placeholder="请输入用户名"
            />
          </Form.Item>

          <Form.Item
            name="password"
            rules={[{ required: true, message: "请输入密码" }]}
          >
            <Input.Password
              size="large"
              addonBefore={<EyeInvisibleOutlined />}
              placeholder="请输入密码"
            />
          </Form.Item>
          <Form.Item
            name="code"
            rules={[{ required: true, message: "请输入图形验证码" }]}
          >
            <Search
              placeholder="请输入图形验证码"
              allowClear
              style={{
                padding: 0,
              }}
              enterButton={
                <img
                  src={imgCode.url}
                  alt=""
                  style={{
                    width: "90px",
                    height: "100%",
                  }}
                  onClick={queryGetCodeImage}
                />
              }
              size="large"
              addonBefore={<SafetyCertificateOutlined />}
            />
          </Form.Item>
          <Form.Item
            style={{
              textAlign: "center",
            }}
          >
            <Button type="primary" htmlType="submit">
              登录
            </Button>
          </Form.Item>
        </Form>
      </Modal>
      <ConfirmUserInfo
        setShowConfirmUserInfo={setShowConfirmUserInfo}
        showConfirmUserInfo={showConfirmUserInfo}
      />
    </div>
  );
}
